module.exports = "<post-editor post=\"post\" form=\"form\" ng-if=\"form.id\"></post-editor>\n";